import { useTranslation } from 'react-i18next';
import Select from 'components/select';
import { Language } from 'shared/types';
import { setIsLanguageChanging } from 'store/calculator/slices/calculator';
import { useAppDispatch } from 'store/hooks';
import {
  mapLanguages,
  translateLangNamesToLocalLang,
  updatePathOnLanguageChange,
} from './logic';
import useGetCountries from 'api/useGetCountries';

interface LanguageSelectProps {
  languages: Language[];
  selectedLanguageAndMarket: string;
  selectedCountryCode: string;
}

const LanguageSelect = ({
  languages,
  selectedLanguageAndMarket,
  selectedCountryCode
}: LanguageSelectProps) => {
  const { t } = useTranslation();
  const { countries } = useGetCountries();
  const dispatch = useAppDispatch();
  const languagesWithTranslatedNames = translateLangNamesToLocalLang(
    t,
    languages,
    selectedCountryCode
  );

  const mappedLanguages = mapLanguages(languagesWithTranslatedNames, selectedCountryCode);

  const changeLanguage = (value: string) =>
    updatePathOnLanguageChange(value, languages, countries);

  return (
    <Select
      onOpen={() => dispatch(setIsLanguageChanging(true))}
      onClose={() => dispatch(setIsLanguageChanging(false))}
      items={mappedLanguages}
      small
      value={selectedLanguageAndMarket}
      onChange={changeLanguage}
      showLabel={false}
      label={t('languageSelect.selectLanguage') ?? ''}
    />
  );
};

export default LanguageSelect;
